/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ProcedureCodeIntegrationViewModel {
  /**
   * Procedure Code Id (not used for Add)
   */
  id?: string | null;
  /**
   * Procedure Code, max length 20
   */
  code?: string | null;
  /**
   * Procedure Description, max length 500
   */
  description?: string | null;
  /**
   * Procedure Amount, defaults to 0
   */
  amount?: number;
  /**
   * Procedure Effective Date start
   */
  procedureEffectiveFrom?: string | null;
  /**
   * Procedure Effective Date end
   */
  procedureEffectiveTo?: string | null;
}
